import LyQuoteBill from './src/main'

LyQuoteBill.install = function (Vue) {
    Vue.component(LyQuoteBill.name, LyQuoteBill)
}

export default LyQuoteBill;